import { IItem } from './item.interface';

export interface ISubsection {
    sectionId?: number;
    sectionType?: string;
    title: string;
    items: IItem[];
}
